// extracted by mini-css-extract-plugin
export default {"inputWrapper":"answered-questions-chart_inputWrapper__NL8Ci","label":"answered-questions-chart_label__BCrZP","textToolTip":"answered-questions-chart_textToolTip__EjreE"};